import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { alertState } from "src/recoil/atoms/global";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useMutation } from "src/Hooks/useReactQuery";
import { editSequenceDetail } from "src/services/sequences";
import APP_ROUTES from "src/routes/routes";

const useEditSequenceDetail = (getRedirectURL = () => APP_ROUTES.SEQUENCES) => {
  const { t } = useTranslation("sequence");
  const navigate = usePatchedNavigate();
  const showAlert = useSetRecoilState(alertState);

  const editSequenceDetailMutation = useMutation({
    mutationFn: ({ data, id }) => editSequenceDetail({ data, id }),
  });

  const submitData = ({ data, id }, callback) => {
    editSequenceDetailMutation.mutate(
      { data, id },
      {
        onSuccess: () => {
          showAlert({
            status: true,
            message: t("detail.edit_success"),
            type: "success",
          });
          navigate(getRedirectURL());
        },
        onError: () => {
          const isSubmitFailed = true;
          callback?.(isSubmitFailed);
        },
        onSettled: () => {
          const isSubmitFailed = false;
          callback?.(isSubmitFailed);
        },
      }
    );
  };

  return {
    editSequenceDetailMutation,
    submitData,
    isLoading: editSequenceDetailMutation.isLoading,
    isError: editSequenceDetailMutation.isError,
    error: editSequenceDetailMutation.error,
  };
};

export default useEditSequenceDetail;
